<div [ngClass]="containerClasses">
    <div class="app-loader__content">
        <div [ngClass]="spinnerClasses"></div>
        <div class="app-loader__text">{{ text }}</div>
    </div>
</div>
